import { useContext } from 'react'
import DataElementsContext from '../context/DataElementsContext'

const useDataElements = () => {
  const ctx = useContext(DataElementsContext)
  if (!ctx) throw new Error('useDataElements must be used within DataElementsProvider')
  return ctx
}

export default useDataElements
